// extracted by mini-css-extract-plugin
module.exports = {"icons":"SbpPaymentBlockIcons_icons_sCUcg"};